import { render, staticRenderFns } from "./registration_guide.vue?vue&type=template&id=6a69fdd6&scoped=true&"
import script from "./registration_guide.vue?vue&type=script&lang=js&"
export * from "./registration_guide.vue?vue&type=script&lang=js&"
import style0 from "./registration_guide.vue?vue&type=style&index=0&id=6a69fdd6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a69fdd6",
  null
  
)

export default component.exports